import { Download } from "features/Download";

export default Download;
